import { Fragment } from "react";
import { validationSchema, ValidationSchemaType } from "../utils";
import { ActionButton, Button, Modal, Toggle } from "components";
import { useApi, useToggle } from "utils";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormSection } from "./FormSection";
import toast from "react-hot-toast";

export function Update(props: {
    dataList: ValidationSchemaType,
    refetch: () => void
}) {
    const { isActive, toggle } = useToggle(false)

    return (
        <Fragment>
            <ActionButton.Update className="join-item" onClick={toggle} />
            {isActive && <ModalSection dataList={props.dataList} toggle={toggle} refetch={props.refetch} />}
        </Fragment>
    )
}

function ModalSection(props: {
    toggle: () => void
    refetch: () => void,
    dataList: ValidationSchemaType
}) {
    const api = useApi()

    const methods = useForm<ValidationSchemaType>({
        resolver: yupResolver(validationSchema),
        defaultValues: props.dataList
    })

    const onSubmit = (value: ValidationSchemaType) => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.put(`/groupasset/edit?mr_group_id=${props.dataList.mr_group_id}`, value),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {
                props.toggle()
                props.refetch()
            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <Modal isOpen title="UPDATE GROUP ASSET" size="xl" closeModal={props.toggle}>
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <FormSection />
                    </Modal.Body>

                    <Modal.Footer className="flex justify-between gap-1">
                        <IsActive dataList={props.dataList} refetch={props.refetch} />
                        <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
                    </Modal.Footer>
                </form>
            </FormProvider>
        </Modal>
    )
}

function IsActive(props: {
    dataList: ValidationSchemaType,
    refetch: () => void
}) {

    const api = useApi()

    const onSubmit = () => {
        return new Promise<void>((resolve) => {
            toast.promise(
                api.put("/groupasset/changestatus",
                    {
                        mr_group_id: props.dataList.mr_group_id,
                        group_asset_del: !props.dataList.is_deleted
                    }),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then(() => {
                props?.refetch && props.refetch()
            }).catch(() => {}).finally(resolve)
        })
    }


    return (
        <Fragment>
            <Toggle
                label="Soft Delete"
                isChecked={props.dataList.is_deleted}
                onClick={() => {
                    onSubmit();
                }} />
        </Fragment>
    )
}